import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isAgentAccount } from "@/lib/agentAccount";

/** Protect Agent Interface routes — requires authenticated agent/manager app_type. */
export default function AgentProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
          <p className="text-sm text-muted-foreground">Loading…</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/agent/login" replace />;
  if (!isAgentAccount(user)) return <Navigate to="/agent/login" replace />;
  return children;
}
